import { UserInfo } from '@shared/types/keycloakTypes';
import Keycloak from 'keycloak-js';
import { ReactNode, useEffect, useState } from 'react';
import {
  VITE_APP_KEYCLOAK_REALM,
  VITE_APP_KEYCLOAK_SCOPE,
  VITE_APP_KEYCLOAK_URL,
  VITE_APP_KEYCLOAK_CLIENT_ID,
} from '@shared/config/envConfig.ts';
import { KeycloakContext } from './context/KeycloakContext';

export const keycloak: Keycloak = new Keycloak({
  url: VITE_APP_KEYCLOAK_URL,
  realm: VITE_APP_KEYCLOAK_REALM,
  clientId: VITE_APP_KEYCLOAK_CLIENT_ID,
});

export function KeycloakProvider({ children }: { children: ReactNode }) {
  const isDeliveryInfo = typeof window !== 'undefined' && window.location.href.includes('delivery-info');
  if (isDeliveryInfo) {
    return <>{children}</>;
  }

  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const [authenticated, setAuthenticated] = useState(false);
  
  useEffect(() => {
    if (keycloak.authenticated === undefined || !keycloak.authenticated) {
      
      keycloak
        .init({
          onLoad: 'login-required',
          checkLoginIframe: false,
          scope: VITE_APP_KEYCLOAK_SCOPE,
        })
        .then((authenticated) => {
          setAuthenticated(authenticated);
          keycloak.loadUserInfo().then((userInfo) => {
            setUserInfo(userInfo as UserInfo);
          });
        })
        .catch(() => {
          // console.log("error", error);
        });

      keycloak.onAuthSuccess = () => {
        // console.log("onAuthSuccess");
      };

      keycloak.onTokenExpired = () => {
        keycloak?.updateToken(5);
        // console.log("onTokenExpired");
      };

      keycloak.onAuthRefreshError = () => {
        // console.log("onAuthRefreshError");
      };

      keycloak.onAuthRefreshSuccess = () => {
        // console.log("onAuthRefreshSuccess");
      };

      keycloak.onAuthError = () => {
        // console.log("onAuthError", error.error_description);
      };
    }
  }, []);
  return (
    <KeycloakContext.Provider value={{ keycloak, authenticated, userInfo }}>
      {!authenticated || !userInfo ? <></> : children}
    </KeycloakContext.Provider>
  );
}
